<div class="filter-group" data-group-visibility-id="showMyFlasksFilters">
  <div class="filter-group-header">
    <div class="filter">
      <span class="input-group-btn">
        <button class="btn toggle-btn caret-btn" [class.off]="!filter.groupVisibility.showMyFlasksFilters" (click)="filter.groupVisibility.showMyFlasksFilters = !filter.groupVisibility.showMyFlasksFilters; updateFilter()"></button>
      </span>
      <span class="filter-body">
        <span filter-title text="Favourite Flasks {{ poe1 ? 'and Tinctures' : 'and Charms' }}" [activeRules]="activeSpecialRules.flaskExceptions">
          Select the flasks you are looking for for your character(s), optionally set minimal conditions, and configure which Variants you're interested in and how they should be highlighted using the <span class="icon icon-equalizer"></span> button.
          <br/><br/>Rules with a <span class="equipment-filter-from-preset-example">gold line</span> to the left were automatically generated from your Class or Progress Preset, and might get changed along with presets.
        </span>
      </span>
    </div>
  </div>
  @if (navigationEnabled || filter.groupVisibility.showMyFlasksFilters) {
    <div class="filter-group-body" [class.collapsed]="!filter.groupVisibility.showMyFlasksFilters">

      @for (flask of filter.flaskFilters; track $index) {
        <app-flask-filter
          [flask]="flask"
          [index]="$index"
          (remove)="removeFlaskType($event)">
        </app-flask-filter>
      }

      <div class="filter filter-padded">
        <button type="button" class="btn clear-btn" style="width: 100%;" (click)="addFlaskType()">
          Add Flask Type
        </button>
      </div>
    </div>
    <div class="clear"></div>
  }
</div>
